import React from "react";
import { conditionallyCreateStyleObj } from "../../../utils";
import { ButtonV2 } from "../../ButtonV2";
import { Heading } from "../../Heading";
import { ImgV2 } from "../../ImgV2";
import { LinkWithTargetAndRel } from "../LinkWithTargetAndRel";
export const CardWithIconTextsLink = ({ iconUrl, subTitle, title, cardBackground, contentTextColor, iconAlt, linkUrl, linkText, linkOpensInNewTab = false, linkDesign, }) => {
    const checkShouldRenderButton = (linkUrl, linkText) => linkUrl && linkText;
    const shouldRenderButton = checkShouldRenderButton(linkUrl, linkText);
    const getCustomCardStyleObj = () => conditionallyCreateStyleObj({
        "--content-text-color": contentTextColor,
        "--background-color": cardBackground,
    });
    return (React.createElement("div", { className: "card-with-icon-texts-link", style: getCustomCardStyleObj() },
        iconUrl && React.createElement(ImgV2, { src: iconUrl, alt: iconAlt || "", className: "card-with-icon-texts-link__icon" }),
        subTitle && (React.createElement("div", { className: "card-with-icon-texts-link__subtitle", dangerouslySetInnerHTML: {
                __html: subTitle,
            } })),
        React.createElement(LinkWithTargetAndRel, { className: "card-with-icon-texts-link__title-link", linkUrl: linkUrl, linkOpensInNewTab: linkOpensInNewTab },
            React.createElement(Heading, { design: "h6-v2dot6", className: "card-with-icon-texts-link__title" }, title)),
        shouldRenderButton && React.createElement(ConditionalCardButton, { linkUrl: linkUrl, linkText: linkText, linkOpensInNewTab: linkOpensInNewTab, linkDesign: linkDesign, classesWrapper: linkDesign ? "" : "card-with-icon-texts-link__link" })));
};
const ConditionalCardButton = ({ linkUrl, linkText, linkOpensInNewTab = false, linkDesign, classesWrapper, }) => {
    if (!linkUrl || !linkText) {
        return null;
    }
    return (React.createElement(ButtonV2, { href: linkUrl, openInNewTab: linkOpensInNewTab, design: linkDesign, classesWrapper: classesWrapper }, linkText));
};
